import type { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';

type AppGlobalProviderProps = {
	children: ReactNode;
};

export const AppGlobalProvider = ({ children }: AppGlobalProviderProps) => {
	return <QueryProvider>{children}</QueryProvider>;
};
